import { gql } from '@apollo/client';

const query = gql`
  query searchSeoState($params: JSONObject) {
    searchSeoState(params: $params)
  }
`;

module.exports = query;
